import React, { Fragment, useState, useEffect } from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import HeaderCard from '../../../Common/Component/HeaderCard';
import config from '../../../../config';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const YearOnYearTable = ({ year, propertyMallCode, className }) => {
    const { t } = useTranslation();
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_id = localStorage.getItem("propertyAccess");
    const token = localStorage.getItem("sessiontoken");
    const currentYear = new Date().getFullYear();
    const selectedYear = year === '' ? currentYear : year;
    const [apiUrl, setApiUrl] = useState('');
    const [apiData, setApiData] = useState([]);

    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };
    const [tabledata, setTableData] = useState([]);

    useEffect(() => {
        if (year !== '' || propertyMallCode !== '') {
            setApiUrl('dashboardfiltered/salescomparisonyoytable')
            const data1 = {
                concessionaire_id,
                property_id,
                year,
                propertyMallCode
            }
            setApiData(data1)
        }
        else {
            setApiUrl('dashboard/salescomparisonyoytable')
            const data2 = {
                concessionaire_id,
                property_id
            }
            setApiData(data2)
        }
    }, [year, propertyMallCode]);

    useEffect(() => {
        if (apiUrl !== '') {
            axios
                .post(`${config.hostname}/${apiUrl}`, apiData, configheader)
                .then((response) => {
                    setTableData(response.data)
                    console.log(response.data)
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [apiUrl, apiData]);

    const num = (v) => (v == null || v === '' ? <span className="dash-muted">—</span> : <span className="dash-val">{v}</span>);

    const delta = (v) => {
        if (v == null || v === '' || v === '_' || isNaN(Number(v))) return <span className="dash-muted">—</span>;
        const n = Number(v);
        const dir = n < 0 ? 'down' : n > 0 ? 'up' : 'flat';
        const arrow = n < 0 ? '↓' : n > 0 ? '↑' : '';
        return <span className={`dash-delta ${dir}`}>{arrow} {Math.abs(n)}%</span>;
    };

    const rows = [
        {
            year: selectedYear - 1,
            sales: tabledata.previousYearSale,
            yoy: null,
            ytd: tabledata.ytdPreviousYear,
            changeytd: null,
            mtd: tabledata.mtdPreviousYear,
            changemtd: null,
        },
        {
            year: selectedYear,
            sales: tabledata.currentYearSale,
            yoy: tabledata.yoyCurrentYear,
            ytd: tabledata.ytdCurrentYear,
            changeytd: tabledata.growthYTD,
            mtd: tabledata.mtdCurrentYear,
            changemtd: tabledata.growthMTD,
        },
    ];

    return (
        <Fragment>
            <Col sm='12' xl='8' className={`${className}`} >
                <Card>
                    <HeaderCard title={<div><div style={{ display: 'flex', alignItems: 'center' }}>
                        <div>{t('Sales Analysis')}</div>
                        <div style={{ fontSize: '0.7em', color: '#777', marginLeft: '10px' }}>{t('Year on year')}</div>
                    </div>
                        <div style={{ fontSize: '0.6em', color: '#777' }}>{t('Values in millions')}</div></div>} />
                    <CardBody>
                        <div className="dash-table-wrap">
                            <table className="dash-table">
                                <thead>
                                    <tr>
                                        <th>{t('Year')}</th>
                                        <th>{t('Sales')}</th>
                                        <th>{t('YOY')}</th>
                                        <th>{t('YTD')}</th>
                                        <th>{t('% Change')}</th>
                                        <th>{t('MTD')}</th>
                                        <th>{t('% Change')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((r) => (
                                        <tr key={r.year}>
                                            <td className="dash-row-head">{r.year}</td>
                                            <td>{num(r.sales)}</td>
                                            <td>{delta(r.yoy)}</td>
                                            <td>{num(r.ytd)}</td>
                                            <td>{delta(r.changeytd)}</td>
                                            <td>{num(r.mtd)}</td>
                                            <td>{delta(r.changemtd)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default YearOnYearTable